import React from 'react';

export default (props) => {
  return (
    <div className={'spinner'}>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32" width="32" height="32">
        <g className="nc-icon-wrapper" fill="#111111">
          <g className="nc-loop_circle-04-32">
            <path data-cap="butt" fill="none" stroke="#111111" strokeWidth="2" strokeMiterlimit="10" d="M2.30867,22.13668 C1.46776,20.26345,1,18.18635,1,16C1,7.71573,7.71573,1,16,1s15,6.71573,15,15s-6.71573,15-15,15 c-3.61453,0-6.93046-1.27847-9.52027-3.40787" transform="rotate(234.13100000005215 16 16)" strokeLinecap="butt" strokeLinejoin="miter"></path>
          </g>
        </g>
      </svg>
      <style jsx>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .spinner {
          width: 32px;
          height: 32px;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          margin: auto;
          animation: spin 700ms linear 0s infinite normal;
          animation-fill-mode: forwards;
          opacity: .25;
        }
      `}</style>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Spinner.js